module.exports = __webpack_public_path__ + "static/media/background__main.14d912ab.jpg";